// removed by extract-text-webpack-plugin
module.exports = {"preloader":"_1ExXSVaPOlhpeDKNBgXU5W"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/MyJournals.mod.css
// module id = 1793
// module chunks = 0